__turbopack_context__.v({
  "container": "Iframe-module-scss-module__JMxT_q__container",
  "containerFull": "Iframe-module-scss-module__JMxT_q__containerFull",
  "containerLg": "Iframe-module-scss-module__JMxT_q__containerLg",
  "containerMd": "Iframe-module-scss-module__JMxT_q__containerMd",
  "containerSm": "Iframe-module-scss-module__JMxT_q__containerSm",
  "containerXl": "Iframe-module-scss-module__JMxT_q__containerXl",
  "containerXxl": "Iframe-module-scss-module__JMxT_q__containerXxl",
  "error": "Iframe-module-scss-module__JMxT_q__error",
  "errorMessage": "Iframe-module-scss-module__JMxT_q__errorMessage",
  "hidden": "Iframe-module-scss-module__JMxT_q__hidden",
  "iframe": "Iframe-module-scss-module__JMxT_q__iframe",
  "iframeResizer": "Iframe-module-scss-module__JMxT_q__iframeResizer",
  "loader": "Iframe-module-scss-module__JMxT_q__loader",
  "loaderSpinner": "Iframe-module-scss-module__JMxT_q__loaderSpinner",
  "spin": "Iframe-module-scss-module__JMxT_q__spin",
  "wrapper": "Iframe-module-scss-module__JMxT_q__wrapper",
});
